<template>
<transition name="height">
    <div class="recent-view" ref="recentView" :style="currentPage > 10 ? 'height: 546px;' : 'height: 429px'">
      <div v-if="!loadSuccess && currentPage === 0" class="error-view">
        <span>{{$t("获取失败，请重试#!!!#src/pages/H5/Cloud/components/hoverDir/RecentStarView.vue_1")}}</span>
        <div class="retry-btn" @click.stop="loadListData">{{$t("重试#!!!#src/pages/H5/Cloud/components/hoverDir/RecentStarView.vue_1")}}</div>
      </div>
      <div v-else-if="
          loadSuccess &&
            (recentList === null ||
              (recentList.length === 0 && currentPage > 0))
        " class="error-view">
        <span>{{$t("暂无内容#!!!#src/pages/H5/Cloud/components/hoverDir/RecentStarView.vue_1")}}</span>
      </div>
      <div v-else class="recent-list" ref="recentList">
        <div class="list-content" ref="listContent" v-infinite-scroll="loadListData" infinite-scroll-disabled="pauseScroll" infinite-scroll-immediate="true">
          <div class="list" v-for="(item, index) in recentList" :key="item.fileId">
            <div class="list-item" :class="{ current: currentFileId === item.fileId }" @click.stop="openFile(item)">
              <div class="file-icon-container">
                <svg-icon class="file-icon" :iconClass="fileAvatar(item)"></svg-icon>
                <hoverHomeMineShortCut class="file-shortcut-icon" v-if="item.shortcut === true"></hoverHomeMineShortCut>
              </div>
              <div :class="[
                  'file-title',
                  currentFileId === item.fileId ? 'current' : '',
                  isTemplate(item) === true ? 'file-title-template' : '',
                ]">
                <span>{{ item.fileName }}</span>
                <svg-icon v-if="isTemplate(item)" :class="[
                    'template_icon',
                    cloudI18n === 'en-us' ? 'template_icon_en' : '',
                  ]" :icon-class="
                    cloudI18n === 'en-us' ? 'template_mark_en' : 'template_mark'
                  "></svg-icon>
              </div>
              <svg-icon v-show="currentFileId === item.fileId" icon-class="icon-file-current" class="file-current-icon"></svg-icon>
            </div>
          </div>
          <div class="file-scrollbar" :class="{ hide: !showScrollbar }" ref="scrollbar"></div>
        </div>
        <div class="list-loading" v-if="loading">
          <svg-icon icon-class="icon-album-list-loading" class="loading-icon"></svg-icon>
        </div>
        <div v-if="isClickMore" class="list-bottom" ref="listBottom"></div>
      </div>
      <div v-if="currentPage === 10 && recentList.length >= 10 && !onScroll" class="recent-bottom" @click.top="loadListData(true)">{{$t("更多#!!!#src/pages/H5/Cloud/components/hoverDir/RecentStarView.vue_1")}}      </div>
    </div>
  </transition>
</template>

<script>
import { getMineFiles, getRecentStars } from "@/api/h5/file";
import { fileImgName } from "@/utils/avatar";
import { mapActions, mapState } from "vuex";
import hoverHomeMineShortCut from "../../assets/hoverHomeMineShortCut.vue";

export default {
  name: "RecentMineView",
  components: {
    hoverHomeMineShortCut,
  },
  data() {
    return {
      loadSuccess: true,
      loading: false,
      noMore: false,
      recentList: [],
      currentPage: 0,
      pageSize: 10,
      showScrollbar: false,
      hideScrollbarTimer: null,
      isClickMore: false,
      observer: null,
      onScroll: false,
    };
  },
  computed: {
    ...mapState({
      currentFileId: (state) => state.docInfo?.fileId,
      recentVisible: (state) => state.recentViewShow,
      cloudI18n: (state) => state.cloudI18n,
    }),
    pauseScroll() {
      return this.loading || this.noMore;
    },
  },
  watch: {
    isClickMore(val) {
      if (val) {
        setTimeout(() => {
          const listBottomEl = this.$refs.listBottom;
          if (listBottomEl) {
            this.observer = new IntersectionObserver(
              this.onListBottomIntersect,
              {
                root: this.$refs.recentList,
                threshold: 0.5,
              }
            );
            this.observer.observe(this.$refs.listBottom);
          }
        });
      }
    },
    recentVisible: {
      handler(v) {
        if (v) {
          this.currentPage = 0;
          this.recentList = [];
          this.noMore = this.onScroll = false;
          this.loadListData();
        }
      },
    },
    currentPage(val) {
      this.setCurrentStarPage(val);
    },
  },
  methods: {
    ...mapActions({
      setCurrentStarPage: "setCurrentStarPage",
    }),
    isTemplate(item) {
      return item.templateType && item.templateType !== 0;
    },
    fileAvatar(item) {
      if (item.productType === "CLOUD_FILE") {
        if (item.fileExtension) {
          return fileImgName(item.fileExtension);
        }
      }
      return fileImgName(item.contentType);
    },
    getRecentFileList(data, requestCallback, errorCallback) {
      getRecentStars(data)
        .then((res) => {
          requestCallback(res);
        })
        .catch((err) => {
          errorCallback();
        });
    },
    loadListData(isClickMore) {
      if (isClickMore !== undefined && isClickMore !== null) {
        this.isClickMore = isClickMore;
      }
      if (this.loading) {
        return;
      }
      if (this.noMore) {
        return;
      }
      this.loading = true;
      let data = {
        since: this.currentPage,
        size: this.pageSize
      };
      this.getRecentFileList(
        data,
        (res) => {
          if (res.code === 200) {
            if (res.data?.result.length > 0) {
              this.noMore = false;
              this.recentList = [...this.recentList, ...res.data.result];
              if (this.recentList.length < 20 && this.currentPage === 10) {
                this.noMore = true;
              }
              this.currentPage += 10;
            } else {
              if (this.currentPage === 0) {
                this.recentList = null;
                this.noMore = true;
              } else {
                this.noMore = true;
                this.currentPage = this.currentPage - 10;
              }
            }
            this.loadSuccess = true;
          } else {
            this.loadSuccess = false;
            if (this.currentPage >= 10) {
              this.currentPage = this.currentPage - 10;
            }
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.loadSuccess = false;
          if (this.currentPage >= 10) {
            this.currentPage = this.currentPage - 10;
          }
        }
      );
    },
    openFile(item) {
      let url = item.fileUrl;
      window.open(url, "_blank");
    },
    onListScroll() {
      this.onScroll = true;
      const listEl = this.$refs.recentList;
      const scrollbarEl = this.$refs.scrollbar;

      const scrollTop = listEl.scrollTop;
      const scrollHeight = listEl.scrollHeight;
      const clientHeight = listEl.clientHeight;
      const scrollbarHeight = (clientHeight * clientHeight) / scrollHeight;
      const scrollbarTop = (scrollTop * clientHeight) / scrollHeight + 40;

      scrollbarEl.style.height = `${scrollbarHeight}px`;
      scrollbarEl.style.top = `${scrollbarTop}px`;

      this.showScrollbar = true;
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = setTimeout(() => {
        this.showScrollbar = false;
      }, 1000);
    },
    onListBottomIntersect(entries) {
      if (entries[0].isIntersecting && this.isClickMore) {
        this.loadListData();
      }
    },
  },
  created() {
    this.loadListData();
  },
  mounted() {
    this.$refs.recentList.addEventListener("scroll", this.onListScroll);
  },
  beforeDestroy() {
    this.$refs.recentList.removeEventListener("scroll", this.onListScroll);
    if (this.hideScrollbarTimer) {
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = null;
    }
    if (this.observer) {
      const listBottomEl = this.$refs.listBottom;
      if (listBottomEl) {
        this.observer.unobserve(this.$refs.listBottom);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.recent-view {
  padding: 0px 8px 8px 8px;
  position: relative;
  // min-height: 350px;
  // max-height: 500px;
  height: 470px;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: height 0.3s ease-out;
  background-color: #fff;
  // border: 1px solid #E6E8EC;
  // box-shadow: 0 8px 12px 0 #1213171a;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  box-sizing: border-box;

  .recent-title {
    margin-left: 11px;
    margin-bottom: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #222329;
    letter-spacing: 0;
  }

  .error-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;

    span {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #222329;
      letter-spacing: 0;
    }

    .retry-btn {
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #5c70ff;
      letter-spacing: 0;
    }
  }

  .recent-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    .list-content {
      display: flex;
      flex-direction: column;

      .list-item {
        width: 288px;
        height: 36px;
        margin-bottom: 4px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;

        &:hover {
          background: #f4f6f9;
        }

        &.current {
          background: #eff1ff;
        }

        .file-icon-container {
          position: relative;
          .file-icon {
            width: 24px;
            height: 24px;
            margin: 0 8px;
            flex-shrink: 0;
          }
          .file-shortcut-icon {
            position: absolute;
            left: 8px;
            bottom: 0;
          }
        }

        .file-title-template {
          max-width: 210px !important;
        }

        .file-title {
          display: flex;
          flex: 1;
          align-items: center;
          margin-right: 14px;
          max-width: 235px;

          span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #222329;
            letter-spacing: 0;
            line-height: 36px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: start;
          }
        }

        .current {
          max-width: 208px;

          span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #5c70ff;
            letter-spacing: 0;
            line-height: 100%;
          }
        }

        .template_icon_en {
          width: 52px !important;
        }

        .template_icon {
          margin: 0px 8px;
          width: 28px;
          height: 16px;
          flex-shrink: 0;
        }

        .file-current-icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          flex-shrink: 0;
        }
      }

      .file-scrollbar {
        position: absolute;
        right: 4px;
        top: 0;
        width: 4px;
        background-color: #dcddde;
        border-radius: 3px;
        transition: opacity 0.2s ease-in-out;

        &.hide {
          opacity: 0;
        }
      }
    }

    .list-loading {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;

      .loading-icon {
        width: 15px;
        height: 16px;
        animation: rotate 2s linear infinite;
      }

      @keyframes rotate {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }
    }

    .list-bottom {
      height: 1px;
      margin-top: -1px;
    }
  }

  .recent-bottom {
    margin-top: 8px;
    margin-left: 11px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #5c70ff;
    letter-spacing: 0;
    cursor: pointer;
  }
}

.recent-view-enter-active,
.recent-view-leave-active {
  transition: height 0.3s ease-out;
}

.recent-view-enter,
.recent-view-leave-to {
  height: 330px;
}

.recent-view-leave-active {
  height: 330px;
}
</style>

<style lang="scss">

</style>
